import {
  FETCH_ADJUSTMENT_DONE_REQUEST,
  FETCH_ADJUSTMENT_DONE_SUCCESS,
  FETCH_ADJUSTMENT_DONE_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  records: [],
  error: null,
  isFetching: false,
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_ADJUSTMENT_DONE_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_ADJUSTMENT_DONE_SUCCESS:
      return {
        ...state,
        records: action.payload,
        error: null,
        isFetching: false,
      }

    case FETCH_ADJUSTMENT_DONE_ERROR:
      return {
        ...state,
        records: [],
        error: action.payload,
        isFetching: false,
      }

    default:
      return state
  }
}
